var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'multi-feature__article': true, 'multi-feature__article--current': _vm.isCurrent },on:{"mouseover":_vm.setCurrent}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }